import { render } from "./LoanDetailsModal.vue?vue&type=template&id=4a267884&scoped=true"
import script from "./LoanDetailsModal.vue?vue&type=script&lang=js"
export * from "./LoanDetailsModal.vue?vue&type=script&lang=js"

import "./LoanDetailsModal.vue?vue&type=style&index=0&id=4a267884&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a267884"]])

export default __exports__